// Couche client du chatbot.
// Toutes les requêtes passent par les routes API Next (server-side) qui proxyent
// les APIs externes définies dans `lib/api-chatbot.js`. Aucune URL/clé externe
// n'est exposée au navigateur. Les signatures et valeurs de retour sont
// identiques à l'ancien `lib/api-chatbot.js` pour ne pas changer les hooks.

async function postJson(url, body) {
    return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
}

async function getJson(url) {
    return fetch(url, { headers: { 'Content-Type': 'application/json' } })
}

export async function askBot(question) {
    const res = await postJson('/api/chatbot/ask', { question })
    return res.json()
}

export async function sendInfoToLlm(question, response, step) {
    const res = await postJson('/api/chatbot/send-info', { question, response, step })
    return res.json()
}

export async function getUserInfoFromBdd(user_id) {
    const res = await getJson(`/api/chatbot/user-info?user_id=${user_id}`)
    return res.json()
}

export async function sendConversationToBdd(role, message, userId, sessionId) {
    const res = await postJson('/api/chatbot/conversation', { role, message, userId, sessionId })
    return res.json()
}

export async function createCalendarEvent(date, titre, sessionId) {
    const res = await postJson('/api/chatbot/calendar', { date, titre, sessionId })
    if (!res.ok) throw new Error('Erreur création événement')
    return res.json()
}

export async function RetrieveMatchings(query) {
    const res = await postJson('/api/chatbot/matchings', { query })
    if (!res.ok) throw new Error('Erreur RetrieveMatchings')
    return res.json()
}

export async function RetrieveSession(session_id = null) {
    const url = session_id
        ? `/api/chatbot/session?session_id=${session_id}`
        : '/api/chatbot/session'
    const res = await getJson(url)
    if (!res.ok) throw new Error('Erreur RetrieveSession')
    return res.json()
}

export async function getSessionInfo(session_id) {
    const res = await getJson(`/api/chatbot/session-info?session_id=${session_id}`)
    if (!res.ok) throw new Error('Erreur récupération session')
    return res.json()
}

export async function getConversationHistory(session_id) {
    const res = await getJson(`/api/chatbot/conversation-history?session_id=${session_id}`)
    return res.json()
}

export async function getConversationHistoryFromGenerative(session_id) {
    const res = await getJson(`/api/chatbot/conversation-history-generative?session_id=${session_id}`)
    return res.json()
}

export async function clearConversationHistory(session_id) {
    const res = await fetch(`/api/chatbot/clear-history?session_id=${session_id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
    })
    return res.json()
}